/* eslint-disable global-require */
const Main = r => require.ensure([], () => r(require('./Main')), 'packages-bundle')
const Form = r => require.ensure([], () => r(require('./Form')), 'packages-bundle')

export default [
  {
    name: 'packages.module',
    path: 'module',
    component: Main,
    meta: { requiresAuth: true },
    children: [
      {
        name: 'packages.module.new',
        path: 'create',
        component: Form
      },
      {
        name: 'packages.module.edit',
        path: ':id/edit',
        component: Form
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/packages/module/routes.js